import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, ArrowLeft } from 'lucide-react';

const ContainerToolbar = ({ 
    onAddNew,
    onSearch,
    onClearSearch,
    searchTerm
}) => {
    const navigate = useNavigate();
    
    return (
        <div className="sticky-top bg-light border-bottom" style={{ top: '0', zIndex: 1020 }}>
            <div className="container-fluid py-2">
                <div className="row align-items-center">
                    <div className="col-auto d-flex align-items-center">
                        <h4 className="mb-0">Containers</h4>
                    </div>
                    <div className="col">
                        <div className="input-group">
                            <input
                                type="search"
                                className="form-control"
                                placeholder="Search containers..."
                                value={searchTerm}
                                onChange={(e) => onSearch(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {searchTerm && (
                                <button 
                                    className="btn btn-outline-secondary" 
                                    onClick={onClearSearch}
                                    title="Clear search"
                                >
                                    ×
                                </button>
                            )}
                        </div>
                    </div>    
                        <div className="col-auto">
                            <div className="btn-group">
                                <button 
                                    className="btn btn-outline-secondary"
                                    onClick={onAddNew}
                                    title="Add New Container"
                                >
                                    <Plus size={18} />
                                </button>
                                <button 
                                    className="btn btn-outline-secondary"
                                    onClick={() => navigate(-1)}
                                    title="Back"
                                >
                                    <ArrowLeft size={18} />
                                </button>
                            </div>
                        </div>
                    </div>
            </div>
            <style jsx>{`
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }
                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }
                .btn:active svg {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default ContainerToolbar;